import { Candidate } from '@/services/candidates';
import CandidateNoteSpecialFieldsComponent from './CandidateNoteSpecialFields.component';

export type CandidateNoteSpecialFieldsProps = {
  name: string;
  candidate: Candidate;
  onChangeSpecialFields: (event: any) => void;
  onSaveSpecialFields: (event: any) => void;
};

const CandidateNoteSpecialFields = function (props: CandidateNoteSpecialFieldsProps): JSX.Element {
  return <CandidateNoteSpecialFieldsComponent {...props} />;
};

export default CandidateNoteSpecialFields;
